module.exports = __webpack_public_path__ + "static/media/img_Characterdesign-Senior-03Third_S11.e33fa2d5.png";